import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DefaultComponentsModule } from 'app/shared/modules/default-components.module';
import { NotificationService } from 'app/shared/components/notification';
import { AssinaturaResponse, PlanoResponse } from 'app/shared/models/ei-models';
import { AssinaturaService, PlanoService } from 'app/shared/services/edduca-imob';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-minha-assinatura',
  imports: [DefaultComponentsModule, CommonModule],
  templateUrl: './minha-assinatura.component.html',
  styleUrl: './minha-assinatura.component.scss'
})
export class MinhaAssinaturaComponent implements OnInit {
  private readonly _planoService = inject(PlanoService);
  private readonly _assinaturaService = inject(AssinaturaService);
  private readonly _notification = inject(NotificationService);
  private readonly _router = inject(Router);

  planos: PlanoResponse[] = [];
  assinatura: AssinaturaResponse | null = null;
  carregando = true;

  async ngOnInit(): Promise<void> {
    try {
      const [planos, assinatura] = await Promise.all([
        lastValueFrom(this._planoService.getAll()),
        lastValueFrom(this._assinaturaService.getAssinaturaAtual()).catch(() => null)
      ]);
      this.planos = (planos || []).map(p => new PlanoResponse(p));
      this.assinatura = assinatura;
    } catch (e: any) {
      this._notification.error(e?.error?.message || 'Falha ao carregar dados da assinatura.');
    } finally {
      this.carregando = false;
    }
  }

  isPlanoAtual(planoId: number): boolean {
    return this.assinatura?.planoId === planoId;
  }

  labelUsuarios(plano: PlanoResponse): string {
    return plano.quantidadeUsuario === 0 ? 'Usuários ilimitados' : `${plano.quantidadeUsuario} usuários`;
  }

  gerenciarAssinatura(): void {
    this._router.navigate(['/minha-imobiliaria']);
  }
}
